/**
 * @desc 列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierBankAccount.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBankAccount/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
